module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [(_vm.loading) ? _c('app-loading') : [_c('div', {
    staticClass: "intro-y flex flex-col-reverse sm:flex-row items-center mt-10"
  }, [_c('div', {
    staticClass: "w-full sm:w-auto relative mr-auto mt-3 sm:mt-0"
  }), _vm._v(" "), _c('div', {
    staticClass: "w-full sm:w-auto flex"
  }, [_c('button', {
    staticClass: "button text-white bg-theme-1 shadow-md mr-2",
    on: {
      "click": function($event) {
        return _vm.toggleModalPoints(true)
      }
    }
  }, [_vm._v("\n          Cargar Puntos\n        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "overflow-auto"
  }, [_c('table', {
    staticClass: "table table-report -mt-2"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center whitespace-no-wrap"
  }, [_vm._v("USUARIO")]), _vm._v(" "), _c('th', {
    staticClass: "text-center whitespace-no-wrap"
  }, [_vm._v("EVENTO")]), _vm._v(" "), _c('th', {
    staticClass: "text-center whitespace-no-wrap"
  }, [_vm._v("FECHA (MES - AÑO)")]), _vm._v(" "), _c('th', {
    staticClass: "text-center whitespace-no-wrap"
  }, [_vm._v("PUNTOS")]), _vm._v(" "), _c('th', {
    staticClass: "text-center whitespace-no-wrap"
  }, [_vm._v("TIPO")]), _vm._v(" "), _c('th', {
    staticClass: "text-center whitespace-no-wrap"
  }, [_vm._v("ACCIONES")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.points), function(point) {
    return _c('tr', {
      key: ("point-" + (point.slug)),
      staticClass: "intro-x"
    }, [_c('td', {
      staticClass: "w-40 text-center"
    }, [_c('div', {
      staticClass: "text-gray-600 text-xs whitespace-no-wrap"
    }, [_c('div', {
      staticClass: "flex flex-wrap"
    }, [_c('div', {
      staticClass: "w-full md:w-1/4"
    }, [_c('div', {
      staticClass: "w-24 h-24 lg:w-12 lg:h-12 image-fit mx-auto"
    }, [(point.user_avatar) ? _c('img', {
      staticClass: "rounded-full",
      attrs: {
        "alt": "Profile",
        "src": point.user_avatar
      }
    }) : _c('img', {
      staticClass: "rounded-full",
      attrs: {
        "alt": "Profile",
        "src": "/static/images/profile.png"
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "w-full md:w-3/4 my-auto whitespace-no-wrap"
    }, [_vm._v("\n                    " + _vm._s(point.user_name) + " "), _c('br'), _vm._v("\n                    " + _vm._s(point.user_email) + "\n                  ")])])])]), _vm._v(" "), _c('td', {
      staticClass: "w-40 text-center"
    }, [_c('div', {
      staticClass: "text-gray-600 text-xs whitespace-no-wrap"
    }, [_vm._v("\n                " + _vm._s(point.event) + "\n              ")])]), _vm._v(" "), _c('td', {
      staticClass: "w-40 text-center"
    }, [(point.month) ? _c('div', {
      staticClass: "text-gray-600 text-xs whitespace-no-wrap"
    }, [_vm._v("\n                " + _vm._s(((String(point.month).padStart(2, '0')) + " - " + (point.year))) + "\n              ")]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "w-40 text-center"
    }, [_c('div', {
      staticClass: "text-gray-600 text-xs whitespace-no-wrap"
    }, [_vm._v("\n                " + _vm._s(point.value) + "\n              ")])]), _vm._v(" "), _c('td', {
      staticClass: "w-40 text-center"
    }, [_c('div', {
      staticClass: "text-gray-600 text-xs whitespace-no-wrap"
    }, [_vm._v("\n                " + _vm._s(point.type) + "\n              ")])]), _vm._v(" "), _c('td', {
      staticClass: "w-40 text-center"
    }, [_c('button', {
      staticClass: "flex items-center p-2 transition duration-300 ease-in-out bg-white hover:bg-gray-200 rounded-md",
      on: {
        "click": function($event) {
          return _vm.showDeleteModal(point.slug)
        }
      }
    }, [_c('Icon', {
      attrs: {
        "name": "trash",
        "classname": "w-4 h-4 mr-2"
      }
    }), _vm._v("Eliminar\n                ")], 1)])])
  }), 0)])]), _vm._v(" "), (_vm.showPointsDeleteModal) ? _c('Modal', {
    attrs: {
      "title": "Eliminar Puntos",
      "size": "lg"
    },
    on: {
      "close": _vm.closeDeleteModal
    }
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.deletePoints()
      }
    }
  }, [_c('div', {
    staticClass: "p-5 grid grid-cols-12 gap-4 row-gap-3"
  }, [_c('div', {
    staticClass: "mt-3 col-span-12 text-center"
  }, [_c('div', [_vm._v("Esta seguro de eliminar los puntos?")])])]), _vm._v(" "), _c('div', {
    staticClass: "px-5 py-3 text-right border-t border-gray-200"
  }, [_c('button', {
    staticClass: "button w-20 border text-gray-700 mr-1",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": _vm.closeDeleteModal
    }
  }, [_vm._v("\n            Cancelar\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "button w-20 bg-theme-1 text-white",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("\n            Eliminar\n          ")])])])]) : _vm._e()], _vm._v(" "), (_vm.modalLoadPoints) ? _c('ModalLoadPoints', {
    on: {
      "close": function($event) {
        return _vm.toggleModalPoints(false)
      },
      "upload": _vm.uploadedPointsFile
    }
  }) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-52ac30be","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/points/ListPoints.vue
// module id = 440
// module chunks = 1